<template>
  <div class="search-box col-lg-12 mb-5 p-0 m-0">
    <div class="input-group">
      <input type="text" class="form-control" :placeholder="$t('searchFor')" :aria-label="$t('searchFor')" v-model="searchText">
      <span class="input-group-btn">
        <button class="btn btn-secondary" type="button" @click="searchClicked">{{$t('search')}}</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchText: '',
      events: []
          
    }
  },
  methods: {
    searchClicked()
    {
      this.$emit('search-clicked', this.searchText);
    }
  }
}
</script>
